import ApiRequest from './apiRequest';

class FeedbackService {
  static async getFeedback() {
    const data = await ApiRequest.apiRequest(
      {method: 'GET', url: `contact-us`}
    );
    return data;
  };

  static async addFeedback(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `contact-us`, body: payload, noResponse: true}
    );
    return data;
  };
}

export default FeedbackService;
